/**
 * Internal dependencies
 */
import Link from "next/link";
import classNames from "classnames";
import { ArticleProps } from "types/article";
import { useRouter } from "next/router";

interface TagAttrProps {
  Name: String;
  slug: String;
  articles: {
    data: ArticleProps[];
  };
}

interface TagsProps {
  id: number;
  attributes: TagAttrProps;
}

interface ListTagsProp {
  tags: TagsProps[];
  currentTag: string | string[];
}

const ListTags: React.FC<ListTagsProp> = ({ tags, currentTag }) => {
  const { locale } = useRouter();
  if (!tags.length) {
    return null;
  }

  return (
    <div className="list-tags">
      <ul>
        {currentTag !== "" && (
          <li>
            <Link href={`/${locale}/blog`}>All</Link>
          </li>
        )}
        {tags.map((tag, i: number) => {
          if (!tag.attributes.articles.data.length) {
            return false;
          }

          return (
            <li
              key={i}
              className={classNames({
                current: currentTag === tag.attributes.slug,
              })}
            >
              <Link
                href={`/${locale}/blog/tag/${tag.attributes.slug}`}
                locale={false}
              >
                {tag.attributes.Name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ListTags;
